import { render, staticRenderFns } from "./PatientCareplan.vue?vue&type=template&id=1f15297c&scoped=true&"
import script from "./PatientCareplan.vue?vue&type=script&lang=ts&"
export * from "./PatientCareplan.vue?vue&type=script&lang=ts&"
import style0 from "./PatientCareplan.vue?vue&type=style&index=0&id=1f15297c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15297c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSpacer})
